import { render, staticRenderFns } from "./SidebarNavDivider.vue?vue&type=template&id=07aca319&"
import script from "./SidebarNavDivider.vue?vue&type=script&lang=js&"
export * from "./SidebarNavDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarNavDivider.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/SidebarNavDivider.vue
// module id = null
// module chunks = 